import { render, staticRenderFns } from "./highVarianceReport.vue?vue&type=template&id=21aa7377&scoped=true&"
import script from "./highVarianceReport.vue?vue&type=script&lang=js&"
export * from "./highVarianceReport.vue?vue&type=script&lang=js&"
import style0 from "./highVarianceReport.vue?vue&type=style&index=0&id=21aa7377&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21aa7377",
  null
  
)

export default component.exports